<template>
    <div>
        <color-picker v-model="handler" @change="inputColor" />
    </div>
</template>
<script>
import ColorPicker from './ColorPicker';
export default {
  props: ['config', 'name', 'value'],
  components:{
      'color-picker':ColorPicker,
  },
  data(){
      return {
          handler:'',
      }
  },
  created(){
      var text = this.value;
      this.handler = text;
  },
  methods:{
    inputColor(newcolor){
        this.handler = newcolor;
        this.change();
    },
    change(){
        var text = this.handler;
        this.$emit('change',text);
    },
  }

}
</script>
